import { AdvisorProvider, AppointmentProvider, AuthProvider, DestinationProvider, HelpAndSupportProvider } from "./index";

const ProvidersWrapper = ({ children }) => {
  const providers = {
    AuthProvider,
    DestinationProvider,
    AdvisorProvider,
    HelpAndSupportProvider,
    AppointmentProvider
  };
  const ProviderComponents = Object.values(providers);

  return (
    <>
      {ProviderComponents.reduceRight(
        (acc, Comp) => (
          <Comp>{acc}</Comp>
        ),
        children
      )}
    </>
  );
};

export default ProvidersWrapper;
